/* RESPONSIBLE TEAM: team-help-desk-experience */
export enum InboxCategory {
  Shared = 'shared',
  Admin = 'admin',
  Team = 'team',
  View = 'view',
  Dashboard = 'dashboard',
}
